import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '@/components/common/Select/Select';
import { IOptions } from '@/data/models/option';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  territories: IOptions<string>[];
  loadTerritories: (inputText: string | null, callback: any) => void;
  handleManufacturing: (field: string, value: any) => void;
};

export default function CountryOfManufactureFormGroup({
  album,
  readonly,
  disabled,
  territories,
  loadTerritories,
  fieldHasErrors,
  findErrorMessage,
  handleManufacturing,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      {territories.length > 0 && (
        <Select
          id="countryOfManufactureTypeahead"
          labelTitle={t('product.editProduct.countryOfManufacture')}
          labelClass="col-sm-3 form-label"
          isClearable={!disabled}
          loadOptions={loadTerritories}
          placeholder=""
          onChange={(e: any) =>
            handleManufacturing('countryOfManufacture', e?.value)
          }
          initialOption={territories.find(
            (tOption) =>
              tOption.value ===
              album.albumMetaData?.manufacturing?.countryOfManufacture
          )}
          className="col-sm-6"
          isDisabled={disabled}
          isReadOnly={readonly}
          hasErrors={fieldHasErrors('CountryOfManufacture')}
          errorMessage={findErrorMessage('CountryOfManufacture')}
          fieldValidationKey={'productEditMode.CountryOfManufacture'}
        />
      )}
    </div>
  );
}
